// extracted by mini-css-extract-plugin
export default {"singleLine":"SbfY2__singleLine"};